import React, { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import { InputWrapper } from '.'
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  AlertTitle,
  CircularProgress,
} from '@mui/material'
import { useMUITheme } from "../../../theme/ThemeProvider";
import { useTheme } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs'
import { AdvancedSearchAction, SavedSearchActionTypes } from '../../../customEnums/index';
import { CreateSearchProps } from 'interfaces/pages/components';
import { TransactionSummaryStyles } from '../../../customStyles/index';
import { AlertStyles } from '../../../customStyles/common';
import { useTableStore } from 'state/TableStore';
import { getCurrentEnv, logger } from "../../../utils";
import { States } from 'interfaces/common';
import { useUserStore } from 'state';
import { savedSearchesReducer } from "../../../pages/TransactionSummary/helpers/savedSearchesReducer";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { extractPageName } from 'common/CustomTable/helpers';
import { useLocation } from 'react-router-dom';


enum ModalActionTypes {
  CHANGE_LABEL_NAME = "CHANGE_LABEL_NAME",
}

const initialModalState = {
  labelName: ""
}

const modalReducer = (currentState: any, { type, payload }: any) => {

  switch (type) {
    case ModalActionTypes.CHANGE_LABEL_NAME:
      const { labelName } = payload;
      return {
        ...currentState,
        labelName
      };
    default: throw new Error('Invalid action type');
  }
};

export const AdvancedSearch: React.FC<CreateSearchProps> = (
  { filters,
    formState,
    setFormValues,
    handleRunSearch,
    setCreateSearch,
    usersPermissions,
    savedSearchState,
    postedConfig,
    displaySavedMessage,
    setDisplaySavedMessage,
    transactionViewing,
    setSearchLength,
    updatingConfig,

  }) => {
  const { mode } = useMUITheme();
  const isDark = mode === 'dark';
  const [modalState, dispatch] = useReducer(modalReducer, initialModalState);
  const { labelName } = modalState;
  const [empty, setEmpty] = useState(true)
  const [loading, setLoading] = useState(false);
  const configService = useTableStore(state => state.configService)
  const setConfigService = useTableStore(state => state.setConfigService)
  const setIsDelete = useTableStore((state) => state.setIsDelete)
  const setConfigFile = useTableStore((state) => state.setConfigFile)
  const setConfigBody = useTableStore((state) => state.setConfigBody)
  const setIsPost = useTableStore((state) => state.setIsPost)
  const setInternalSearchArray = useTableStore(state => state.setInternalSearchArray)
  const STATE = getCurrentEnv
  const config = useUserStore(state => state.config)
  const { softLimit, hardLimit, limitLowerSearchDate, lowerSearchDateLimit } = config.transactionViewing
  const userConfig = useUserStore(state => state.userConfig)
  const { isAdmin } = userConfig
  const { searchData } = configService
  const loadedData = useMemo(() => ({ ...searchData }), [searchData]);
  const [savedSearches, dispatchSearch] = useReducer(savedSearchesReducer, loadedData);
  const zoomLevel = useTableStore(state => state.zoomLevel);
  const locationObj = useLocation()
  const pageName = extractPageName(locationObj.pathname)

  dayjs.extend(isSameOrBefore);


  // Display success message when posting config, defined in the config service hook, is set to true
  useEffect(() => {
    if (postedConfig) {
      setDisplaySavedMessage(postedConfig)
    }
  }, [postedConfig]);

  const onLabelNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: ModalActionTypes.CHANGE_LABEL_NAME, payload: { labelName: e.target.value } });
    if (e.target.value.length < 1) {
      setDisplaySavedMessage(false)
    }
  };

  const handleSavedSearch = async () => {
    await dispatchSearch(
      {
        type: SavedSearchActionTypes.ADD_SAVED_SEARCH,
        savedSearch: {
          label: labelName,
          searchParams: formState[0]
        },
        setters: {
          setIsDelete,
          setConfigFile,
          setConfigBody,
          setIsPost,
          setInternalSearchArray
        }
      }
    );
    setConfigService({ ...configService, postedConfig: false })

    console.log('this is the function being invoked ')
    setFormValues({});
  };

  const { firstName, lastName, status, transactionType, lowerDate, upperDate, rfp, stateRFPCode, days } = formState[0]
  const dispatchFormValues = formState[1]

  useEffect(() => {
    console.log('savedsearchstate', savedSearchState)
    console.log('createSearch reset formState component lastName: ', formState)
    const searchParams = formState[0]
    console.log('createSearch searchParams: ', searchParams)
    const searchParamsKeys = Object.keys(searchParams)
    const textFieldsEmpty = searchParamsKeys.filter(key => !['days', 'lowerDate', 'upperDate'].includes(key)).every(key => (searchParams[key] as string).trim() === '')
    const dateFieldsEmpty = !lowerDate && !upperDate;
    setEmpty(textFieldsEmpty && dateFieldsEmpty)
  }, [formState])

  console.log('debug select render AdvancedSearch')

  const debugExtend = {
    identifier: "debug extendView",
    pageName: "transaction-summary",
    thingToDebug: "extend",
    paramsToLog: {
      days,
      transactionViewing,
      toggleChecked: days === transactionViewing!.hardLimit!.toString()
    }
  }
  // logger(debugExtend)

  let statusTypes = filters.find((filter) => filter.filterColumn === "status")!.filterValues

  const validateDateRangeFields = () => {
    if (!lowerDate && !upperDate) return true

    return lowerDate?.isValid() && upperDate?.isValid();
  }

  const isValidDateRange = validateDateRangeFields();

  console.log('debug config in AdvancedSearch: ', config)
  return (
    <Dialog fullWidth={true} open={true} PaperProps={{ sx: { ...TransactionSummaryStyles.createSearchDialog, transform: `scale(${1 / zoomLevel})` } }} data-testid="advanced-search-modal">
      <DialogTitle>
        <Typography variant='h1' sx={{ fontSize: "1.125rem" }} color='text.primary'>
          SEARCH PARAMETERS

        </Typography>
      </DialogTitle>
      <DialogContent sx={TransactionSummaryStyles.createSearchDialogContent}>
        <Typography variant='body1' sx={{ width: "100%", height: "40px", mb: '0.75rem' }}>
          Define one or more search parameters and select 'Run Search'. Otherwise, save  your search as a template or exit without searching.
        </Typography>
        <InputWrapper>
          <TextField
            label="First Name"
            name="firstName"
            data-testid="firstname-text-field"
            value={firstName}
            placeholder="First Name"
            variant="outlined"
            sx={TransactionSummaryStyles.createSearchTextField}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatchFormValues({ type: AdvancedSearchAction.FIRST_NAME, value: e.target.value })}
          />
          <TextField
            label="Last Name"
            name="lastName"
            data-testid="lastname-text-field"
            value={lastName}
            placeholder="Last Name"
            variant="outlined"
            sx={TransactionSummaryStyles.createSearchTextField}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatchFormValues({ type: AdvancedSearchAction.LAST_NAME, value: e.target.value })}
          />
        </InputWrapper>

        <InputWrapper>
          <FormControl>
            <InputLabel color="secondary">Status</InputLabel>
            <Select
              onChange={(e: any) => dispatchFormValues({ type: AdvancedSearchAction.STATUS, value: e.target.value })}
              variant="outlined"
              data-testid="status-select"
              sx={TransactionSummaryStyles.createSearchTextField}
              label="Status">
              {
                Object.keys(statusTypes).map((key) => {
                  return (
                    <MenuItem
                      value={statusTypes[key].label}
                      data-testid={`${statusTypes[key].label.toLowerCase().replace(/ /g, '-')}-menu-item`}
                    >
                      {statusTypes[key].label}
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel>Transaction Type</InputLabel>
            <Select
              onChange={(e: any) => dispatchFormValues({ type: AdvancedSearchAction.TYPE, value: e.target.value })}
              sx={TransactionSummaryStyles.createSearchTextField}
              label="Transaction Type"
              data-testid="transaction-type-select"
            >
              {
                config.pages[pageName].advancedSearch.transactionTypes.map((type) => {
                  return <MenuItem value={type} data-testid={`${type.toLowerCase().replace(/ /g, '-')}-menu-item`}>{type}</MenuItem>
                })
              }
            </Select>
          </FormControl>
        </InputWrapper>
        <InputWrapper>
          <DatePicker
            minDate={isAdmin === 'true' ? null : dayjs().subtract(softLimit, 'days')}
            maxDate={upperDate || dayjs()}
            value={lowerDate}
            label="Lower date"
            slotProps={{
              textField: {
                placeholder: "MM / DD / YYYY",
              },
            }}
            sx={TransactionSummaryStyles.createSearchTextField}
            onChange={(newValue) => dispatchFormValues({ type: AdvancedSearchAction.LOWER_DATE, value: newValue })}
          />
          <DatePicker
            minDate={lowerDate}
            maxDate={lowerDate && dayjs(lowerDate).add((isAdmin === 'true') ? hardLimit : softLimit, 'days').isSameOrBefore(dayjs())
              ? dayjs(lowerDate).add((isAdmin === 'true') ? hardLimit : softLimit, 'days')
              : dayjs()
            }
            value={upperDate}
            label={`Upper date ${lowerDate ? 'required' : ''} `}
            slotProps={{
              textField: {
                placeholder: "MM / DD / YYYY",
                required: lowerDate,
              },
            }}
            sx={{
              ...TransactionSummaryStyles.createSearchTextField,
              ...(lowerDate && !upperDate) && {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'red'
                  }
                }
              }
            }}
            onChange={(newValue) => dispatchFormValues({ type: AdvancedSearchAction.UPPER_DATE, value: newValue })}
          />

          {/*
            May add expiry range within at some point in the future
            <FormControl>
              <InputLabel>Expiry Range Within</InputLabel>
              <Select sx={{width: "418px", height: "56px"}} label="Expiry Range Within"></Select>

            </FormControl>*/}
        </InputWrapper>
        {
          lowerDate &&
          <Container disableGutters sx={TransactionSummaryStyles.createSearchSwitchContainer}>
            <Typography sx={{ display: 'flex', flexDirection: "row" }}>
              Records can be searched within a
              &nbsp;
              <Typography color='#430099'>{`${(isAdmin === 'true') ? hardLimit : softLimit} day`}</Typography>
            </Typography>
            &nbsp; range.
          </Container>
        }
        {/* No longer needed. Keeping for now in case this becomes repurposed. 
          usersPermissions.viewAdvancedSearchExtend && (
            <Container disableGutters sx={TransactionSummaryStyles.createSearchSwitchContainer}>
              <Switch
                checked={days === transactionViewing!.hardLimit!.toString() ? true : false}
                color='secondary'
                sx={{
                  '.MuiSwitch-track ': {
                    backgroundColor: '#10111C'
                  }
                }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatchFormValues({ hardLimit: transactionViewing!.hardLimit, type: AdvancedSearchAction.DAYS, value: e.target.checked })}
              />
              {//Make value 30 day window value configureable}
              <Typography>Enable searching of records beyond the default 30 day window</Typography>
            </Container>
          )
        */}


        <FormControl sx={{ flexGrow: 1, height: "56px" }}>
          <TextField
            label={
              STATE === States.GA
                ? "Statute"
                : "Reason Fingerprinted"
            }
            name="reasonFingerprinted"
            data-testid="reason-finger-printed-text-field"
            value={
              STATE === States.GA
                ? stateRFPCode
                : rfp
            }
            onChange={(e: any) => dispatchFormValues({ type: AdvancedSearchAction.RFP, value: e.target.value })}
            placeholder="Reason Fingerprinted"
            variant="outlined"
            sx={{ width: "100%", height: "56px" }}>
          </TextField>

          {/*
       Removing until we can populate this from some service
       <InputLabel sx={{ color: theme.palette.text.primary }}>Reason Finger Printed</InputLabel>
        <Select value={reasonFingerprinted} onChange={(e: any) => dispatchFormValues({type: AdvancedSearchAction.RFP, value: e.target.value})} sx={{ flexGrow: 1, height: "56px" }} label="Reason Finger Printed">
          <MenuItem value={"VISA APPLICANT"}>VISA APPLICANT</MenuItem>
          <MenuItem value={"NCPA/VCA VOLUNTEER"}>NCPA/VCA VOLUNTEER</MenuItem>
          <MenuItem value={"Firearms"}>Firearms</MenuItem>
    </Select>*/}

        </FormControl>
        <Divider />

        <Container disableGutters sx={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "61px", width: "100%" }} data-testid="save-your-search-container">
          <Typography sx={{ width: "100%" }} variant="h6" color="text.primary">SAVE YOUR SEARCH</Typography>
          <Typography sx={{ width: "100%" }} variant='body1'>Save your search as a template. Search templates will be added to the 'Search' field.</Typography>
        </Container>

        {displaySavedMessage && (
          <Alert severity="success" variant='standard' sx={{ ...AlertStyles.success, width: '100%', display: 'flex' }} data-testid="success-alert">
            <AlertTitle sx={{ color: 'success.contrastText' }}>
              Search Saved!
            </AlertTitle>
            <Typography color='success.contrastText' variant='body2'>
              This saved search has been added to the "Search" field.
            </Typography>
          </Alert>
        )}


        <TextField
          label="Saved Search Name"
          data-testid="saved-search-name-text-field"
          sx={{ height: "56px", width: "100%" }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onLabelNameChange(e)}
          placeholder="Saved search name"
        />
        <Button
          disabled={labelName.length === 0 || empty || !isValidDateRange
            ? true
            : updatingConfig || labelName.length === 0
              ? true
              : false}
          onClick={() => { handleSavedSearch(); setLoading(true); }}
          data-testid="save-search-button"
          variant="contained"
          color='secondary'
          sx={TransactionSummaryStyles.createSearchSaveButton}>
          {updatingConfig ? <CircularProgress size='1.5rem' sx={{ color: '#fff' }} /> : "Save Search"}
        </Button>
      </DialogContent>
      <DialogActions sx={{ p: '1rem 1.5rem' }}>
        <Button
          onClick={() => {

            setConfigService({ ...configService, postedConfig: false })
            //setPostedConfig(false);
            setCreateSearch(false);
            setFormValues({});
            setDisplaySavedMessage(false);
            dispatchFormValues({ type: AdvancedSearchAction.RESET, hardLimit });
          }}
          data-testid="cancel-button"
          variant="outlined"
          color='secondary'
          sx={{ ...TransactionSummaryStyles.createSearchButtons, color: isDark ? '#fff' : null }}>
          CANCEL
        </Button>
        <Button
          disabled={empty || !isValidDateRange}
          onClick={() => handleRunSearch()}
          data-testid="run-search-button"
          variant="contained"
          color='secondary'
          sx={{ ...TransactionSummaryStyles.createSearchButtons, width: "138px" }}
        >
          RUN SEARCH
        </Button>
      </DialogActions>
    </Dialog>
  )
}